import Slidermodal from './slider-modal';

export default class SliderSingle {
   constructor() {
      this.slider = $('.slider-single').not('.slick-initialized')
      this.init()
   }

   init() {
      if (this.slider.length > 0) {
         this.slider.on('init', function(event, slick, direction) {
            new Slidermodal();
         });

         this.slider.slick({
            infinite: true,
            dots: false,
            autoplay: false,
            autoplaySpeed: 5000,
            arrows: true,
            speed: 500,
            fade: true,
         })
      }
   }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/slider-single.js
// module id = 18
// module chunks = 0